"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";
import type { ImageGallery as ImageGalleryComponent } from "./imageGallery/ImageGallery";

const ImageGallery = dynamic(
  () => import("./imageGallery/ImageGallery").then((mod) => mod.ImageGallery),
  { ssr: false }
);

type ImageGalleryProps = ComponentProps<typeof ImageGalleryComponent>;

export function LazyGallery(props: ImageGalleryProps) {
  return <ImageGallery {...props} />;
}
